import { useNavigate } from 'react-router-dom';
import './BackButton.css'

export default function BackButton() {
  const navigate = useNavigate();
  return(
        <div className="back-btn-main">
          <button
            className='back-btn'
            onClick={()=>navigate('/home')}
            aria-label="Voltar para Home"
            title="Voltar"
          >
            ←
          </button>
        </div>
  )
}